export default __webpack_public_path__ + "static/media/Ballroll_00316.9aabb436.png";